import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

@Injectable()
export class SharedModalService {
  constructor(private httpClient: HttpClient) { }

  // Start Refactoring

  getJobRequestHistories(params): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests-histories', {
        params,
        observe: 'response',
      })
      .toPromise();
  }

  getJobRequestActionHistories(params): any {
    return this.httpClient
      .get(environment.api.serverUrl + '/jobrequests-histories/actions', {
        params,
      })
      .toPromise();
  }

  getJobRequestTicketHistories(parcelId): any {
    return this.httpClient
      .get(environment.api.support + '/parcel/' + parcelId)
      .toPromise();
  }

  getPackingSlip(nid, params): any {
    return this.httpClient
      .get(
        environment.api.serverUrl + `/packingslips/${nid}`,
        { params }
        // { observe: 'response' }
      )
      .toPromise();
  }

  shareRecordWithClient(id): any {
    return this.httpClient
      .post(environment.api.serverUrl + `/jobrequests/records/${id}/share`, {})
      .toPromise();
  }

  unshareRecordWithClient(payload): any {
    console.log(payload);
    return this.httpClient
      .post(environment.api.serverUrl + '/jobrequests/records/unshare', payload)
      .toPromise();
  }

  // End Refactoring **

  getJobRequestHistory(query, populate): any {
    return this.httpClient
      .get(
        environment.api.jobRequestHistory +
        '?sort=-createdAt&query=' +
        JSON.stringify(query) +
        '&populate=' +
        JSON.stringify(populate),
        { observe: 'response' }
      )
      .toPromise();
  }

  getJobRequestActionHistory(query, populate): any {
    return this.httpClient
      .get(
        environment.api.serverUrl +
        '/ActionsHistory?sort=-createdAt&query=' +
        JSON.stringify(query) +
        '&populate=' +
        JSON.stringify(populate)
      )
      .toPromise();
  }
  getAllpackingSlip(query, populate, page, itemsPerPage): any {
    var skip = (page - 1) * itemsPerPage;
    var limit = itemsPerPage;
    return this.httpClient
      .get(
        environment.api.packingSlip +
        '?sort=-updatedAt&query=' +
        query +
        '&populate=' +
        populate +
        '&skip=' +
        skip +
        '&limit=' +
        limit,
        { observe: 'response' }
      )
      .toPromise();
  }

  getJobRequestCallsHistory(jobId): any {
    return this.httpClient
      .get(environment.api.backendBase + '/jobrequests/records', {
        params: { _id: jobId },
      })
      .toPromise();
  }
}
